import { BrandBar } from 'app/src/features/Home/components/BrandBar'
import { CampaignSelectionDialog } from 'app/src/features/Home/components/CampaignSelectionDialog/CampaignSelectionDialog'
import { UserSelfRegistration } from 'app/src/features/UserSelfRegistration'
import { BreadCrumb, ContactUsSidePanel, SessionExpiredError, UnrecoverableError, UserSidePanel } from 'app/src/shared/components'
import { useWebAppContext } from 'app/src/shared/hooks'

// (no React hooks needed; component derives values directly from context)
import { AdminPanel } from 'app/src/features/DemoApp'
import { DemoLabel } from 'app/src/features/DemoApp/DemoLabel'
import { ReminderBalanceDialog } from 'app/src/features/Home/components/ReminderBalanceDialog/ReminderBalanceDialog'
import { UserForbidden } from 'app/src/features/UserForbidden'
import { isDemoApp, shouldShowDemoLabel } from 'app/src/shared/helpers'
import { calculateDateDifferenceInDays, isDateAfter } from 'app/src/shared/helpers/date/dateutils'
import { DateTime } from 'luxon'
import { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { AppBar } from './components/AppBar'
import { Footer } from './components/Footer'
import { ToastMessages } from './components/ToastMessages/ToastMessages'

export function Home() {
  const context = useWebAppContext()
  useEffect(() => {
    if (!sessionStorage.getItem('spendingReminderShown')) {
      sessionStorage.setItem('spendingReminderShown', 'true')
    }
  }, [])

  useEffect(() => {
    console.log(context.userInfo.welfareCampaign.configuration.frontend.templateId)
  }, [context.userInfo.welfareCampaign.configuration.frontend.templateId])
  const [dialogVisible, setDialogVisible] = useState<boolean>(false)

  // Derive UI flags directly from context to avoid duplicated state & race conditions
  const sessionExpired = !!context.sessionExpired
  const canSelfRegister = !!context.userInfo?.canSelfRegister
  const isForbidden = !!context.userInfo?.isForbidden
  // Ensure translation key resolves: use the same key for both title and type so UnrecoverableError's t(convertedError.type) finds it
  /*
  const handledError: ErrorModel | undefined = isForbidden
    ? { status: 403, title: 'welfareforbidden', type: 'UserForbidden' }
    : undefined

  */
  const handledError = undefined

  const campaignEndDate = DateTime.fromISO(context.userInfo.welfareCampaign?.fruitionDateTo)

  const today = DateTime.now()
  const diff = calculateDateDifferenceInDays(today.toJSDate(), campaignEndDate.toJSDate())
  const isTodayAfterCampaignEnd = isDateAfter(today.toJSDate(), campaignEndDate.toJSDate())

  const expirationDays = context.userInfo.welfareCampaign?.configuration?.spendingReminder?.thresholdDays

  const shouldShowSpendingReminder =
    Number(expirationDays) > 0 && diff > 0 && Number(expirationDays) >= diff && !isTodayAfterCampaignEnd
  const [showSpendingReminder, setShowSpendingReminder] = useState(true)
  const reminderSession = sessionStorage.getItem('spendingReminderShown') === 'true'

  if (isForbidden) return <UserForbidden />

  if (sessionExpired) return <SessionExpiredError />
  if (canSelfRegister) return <UserSelfRegistration />

  return (
    <>
      {shouldShowDemoLabel() && <DemoLabel />}
      <nav className={`${isDemoApp() ? 'demo' : ''}`}>
        <AppBar setDialogVisible={setDialogVisible} />
        <ContactUsSidePanel />
        <UserSidePanel />
        <ToastMessages />
        <BrandBar />
        <BreadCrumb />
      </nav>
      <main>
        <div className='min-h-lvh'>{!handledError ? <Outlet /> : <UnrecoverableError errorModel={handledError} />}</div>
        <AdminPanel dialogVisible={dialogVisible} setDialogVisible={setDialogVisible} />
      </main>
      {context.showCompanySelectionDialog && (
        <CampaignSelectionDialog
          onHide={() => {
            context.update({ showCompanySelectionDialog: false })
            context.update({ showUserSidePanel: false })
            setShowSpendingReminder(true)
          }}
        />
      )}
      {reminderSession && !context.showCompanySelectionDialog && showSpendingReminder && shouldShowSpendingReminder && (
        <ReminderBalanceDialog onClose={() => setShowSpendingReminder(false)} showSpendingReminder={showSpendingReminder} />
      )}
      <footer>
        <Footer />
      </footer>
    </>
  )
}
